/* eslint-disable react/jsx-key */
import React, { useState } from 'react'
import { strCol, intCol, dateCol } from '@integec/grid-tools/lib/cols'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'
import { getApiTargetInfo } from 'core'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import { connect } from 'react-redux'
import {
  getHolidayMgmtInfo,
  postHolidayMgmtInfo,
  deleteHolidayMgmtInfo,
} from 'api/pgads.js'
import { Input, Button, DatePicker, Select, InputNumber } from 'antd'
import CommonScreen from './CommonScreen'
const company = {
  ALL: 'ALL',
}

const headers = [
  strCol({
    ident: 'company',
    display: 'Company',
    isKey: true,
    ...toSelectionColProps(company),
    width: 350,
  }),
  intCol({
    ident: 'year',
    display: 'Year',
    isKey: true,
  }),
  dateCol({
    ident: 'holidayDate',
    display: 'Holiday Date',
    isKey: true,
  }),
  strCol({
    ident: 'holiday',
    display: 'Holiday',
    width: 150,
    isRequired: true,
  }),
  modifierCol,
  modifiedDateCol,
]

const retrieveTask = apiTargetInfo => getHolidayMgmtInfo(apiTargetInfo)

const modifyTask = apiTargetInfo => data =>
  postHolidayMgmtInfo(apiTargetInfo)(data)

const deleteTask = apiTargetInfo => data =>
  deleteHolidayMgmtInfo(apiTargetInfo)(data)

const title = 'Holiday Management'

const HolidayMgmt = () => {
  const [insertEvent, setInsertEvent] = useState(false)

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <table
        style={{
          width: '70%',
          borderSpacing: '10px',
          borderCollapse: 'inherit',
        }}
      >
        <tbody>
          <tr>
            <td
              style={{
                width: '120px',
              }}
            >
              <div
                style={{
                  display: 'grid',
                  justifyContent: 'end',
                  alignContent: 'center',
                }}
              >
                Company :{' '}
              </div>
            </td>
            <td>
              <Select
                style={{ width: '200px' }}
                id="company"
                placeholder="Select a Company"
                value={insertData.company}
                onChange={value => {
                  setInsertData({ ...insertData, company: value })
                }}
              >
                <Select.Option key="ALL">ALL</Select.Option>
              </Select>
            </td>
            <td style={{ width: '80px' }}>
              <div
                style={{
                  display: 'grid',
                  justifyContent: 'end',
                  alignContent: 'center',
                }}
              >
                Year :{' '}
              </div>
            </td>
            <td style={{ width: '300px' }}>
              <InputNumber
                placeholder="Enter Year"
                value={insertData.year}
                maxLength={4}
                minLength={4}
                onChange={value =>
                  setInsertData({ ...insertData, year: value })
                }
              />
            </td>
            <td />
          </tr>
          <tr>
            <td>
              <div
                style={{
                  display: 'grid',
                  justifyContent: 'end',
                  alignContent: 'center',
                }}
              >
                Holiday Date :{' '}
              </div>
            </td>
            <td>
              <DatePicker
                id="holidayDate"
                allowClear={false}
                format="MM/DD/YYYY"
                value={insertData.holidayDateMom}
                onChange={date => {
                  setInsertData({
                    ...insertData,
                    holidayDateMom: date,
                    holidayDate: date.format('YYYY-MM-DD'),
                  })
                }}
              />
            </td>
            <td>
              <div
                style={{
                  display: 'grid',
                  justifyContent: 'end',
                  alignContent: 'center',
                }}
              >
                Holiday :{' '}
              </div>
            </td>
            <td>
              <Input
                placeholder="Enter Holiday"
                value={insertData.holiday}
                onChange={e =>
                  setInsertData({ ...insertData, holiday: e.target.value })
                }
                maxLength={15}
              />
            </td>
            <td>
              <Button type="primary" onClick={() => onAdd(true)}>
                Add
              </Button>
            </td>
            <td>
              <Button type="primary" onClick={() => onAdd(false)}>
                Add & Hide
              </Button>
            </td>
            <td>
              <Button type="danger" onClick={onCancel}>
                Cancel
              </Button>
            </td>
          </tr>
        </tbody>
      </table>
    )
  }
  return [
    <CommonScreen
      title={title}
      header={headers}
      saveTask={modifyTask}
      retrieveTask={retrieveTask}
      deleteTask={deleteTask}
      altBy={d => d.unit}
      autoRetrieve
      sortOptions={[
        { ident: 'company', display: 'Company', sortOrder: 'asc' },
        // { ident: 'year', display: 'Year', sortOrder: 'asc' },
        { ident: 'holidayDate', display: 'Holiday Date', sortOrder: 'desc' },
      ]}
      totalWidth={1100}
      insertComp={insertEvent && insertComp}
      insertCompHeight={150}
      onInsertEvent={b => setInsertEvent(b)}
    />,
  ]
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(HolidayMgmt)
